import _slicedToArray from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './AutocompleteField.css';
import React from 'react';
import { useHistory } from "react-router-dom";
import addQueryString from "./index";
import { qsToObject } from "../../utils/querystring";
import { canUseDOM } from '../../utils';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
var SuggestionsList = function SuggestionsList(_ref) {
  var suggestionList = _ref.suggestionList,
    setIsOpen = _ref.setIsOpen,
    sendRequestHandler = _ref.sendRequestHandler;
  var drop = React.useRef(null);
  var handleOutClick = function handleOutClick(_ref2) {
    var target = _ref2.target;
    if (!target.closest(".".concat(drop.current.className))) {
      setIsOpen(false);
    }
  };
  var handleItemClick = function handleItemClick(title) {
    setIsOpen(false);
  };
  React.useEffect(function () {
    if (canUseDOM) {
      document.body.addEventListener('click', handleOutClick);
      return function () {
        return document.body.removeEventListener('click', handleOutClick);
      };
    }
  }, []);
  return /*#__PURE__*/React.createElement("ul", {
    className: "suggestions-list autocomplete",
    ref: drop
  }, suggestionList.map(function (suggestion) {
    return /*#__PURE__*/React.createElement("li", {
      className: "suggestion-item",
      onClick: function onClick() {
        return handleItemClick(suggestion.title);
      }
    }, /*#__PURE__*/React.createElement("a", {
      "aria-label": "Title",
      "aria-labelledby": "Title",
      href: suggestion.url
    }, suggestion.title));
  }));
};
var AutocompleteField = function AutocompleteField(_ref3) {
  var setFilter = _ref3.setFilter,
    facetsName = _ref3.facetsName,
    clearAlllFilters = _ref3.clearAlllFilters,
    _ref3$hits = _ref3.hits,
    hits = _ref3$hits === void 0 ? [] : _ref3$hits,
    placeholder = _ref3.placeholder;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var history = useHistory();
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    firstRender = _React$useState2[0],
    setFirstRender = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isOpen = _React$useState4[0],
    setIsOpen = _React$useState4[1];
  var borderRadius = {
    borderRadius: '4px 4px 0 0'
  };
  var _React$useState5 = React.useState(''),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    value = _React$useState6[0],
    setValue = _React$useState6[1];
  var handleOnChange = function handleOnChange(event) {
    setIsOpen(true);
    setValue(event.target.value);
  };
  React.useEffect(function () {
    if (!firstRender) {
      var timeoutId = setTimeout(function () {
        return setFilter(value);
      }, 500);
      return function () {
        return clearTimeout(timeoutId);
      };
    } else {
      setFirstRender(false);
    }
  }, [value]);
  var sendRequestHandler = function sendRequestHandler(title) {
    setValue(title);
    addQueryString(facetsName, title, history);
    setFilter(title);
  };
  React.useEffect(function () {
    var urlParams = qsToObject(window.location.href);
    var title = urlParams['title'];
    if (title) {
      setValue(title.split('+').join(' '));
    }
  }, []);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter__field "
  }, /*#__PURE__*/React.createElement("div", {
    className: "input-search-box"
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    className: "input-search-text",
    placeholder: placeholder,
    style: isOpen && hits.length ? borderRadius : undefined,
    value: value,
    onChange: handleOnChange,
    onClick: function onClick() {
      return setIsOpen(true);
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: "search-icon"
  })), isOpen && /*#__PURE__*/React.createElement(SuggestionsList, {
    suggestionList: hits,
    setIsOpen: setIsOpen,
    sendRequestHandler: sendRequestHandler
  })));
};
var StyledWrapper = function StyledWrapper(_ref4) {
  var children = _ref4.children,
    rtl = _ref4.rtl;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : '')
  }, children);
};

// export default DropDown;
export default AutocompleteField;
var commonStyles = "c1liztjw";
var rtlStyles = "r4sot6y";